/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Sch_Err_Too_Many_StatusesInputs */

const en_sch_err_too_many_statuses = /** @type {(inputs: Sch_Err_Too_Many_StatusesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A workflow can have at most ${i?.max} statuses.`)
};

const de_sch_err_too_many_statuses = /** @type {(inputs: Sch_Err_Too_Many_StatusesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein Workflow kann höchstens ${i?.max} Status haben.`)
};

/**
* | output |
* | --- |
* | "A workflow can have at most {max} statuses." |
*
* @param {Sch_Err_Too_Many_StatusesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_too_many_statuses = /** @type {((inputs: Sch_Err_Too_Many_StatusesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Too_Many_StatusesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_too_many_statuses(inputs)
	return en_sch_err_too_many_statuses(inputs)
});